import React, {Component} from 'react';
import _ from "underscore";

import attributeIds from "../../../api/attributeIds";

import infusionChairsIcon from "../../../img/ic-infusion-chairs.svg";
import languagesSpokenIcon from '../../../img/ic-languages-spoken.svg';

import "../../../css/LocationDetail.css";

class QuickFactsPanel extends Component {
    buildQuickFact(icon, header, values){
        return (
             <div className="container vertical-center quickFactsItem">
                   <img className="quickFactsIcon" src={icon} alt="quick facts icon"/>
                   <div className="container vertical" style={{flex: 8, marginLeft: "16px"}}>
                     <div className="quickFactsSubHeader">{header}</div>
                     {values && values.length && values[0] != null ?
                         values.map( (value, index) => {
                             return (
                                 <div className="quickFactsValue" key={"quick-fact-" + index}>{value}</div>
                             )
                         })
                         :
                         <div className="quickFactsValue">This information is not available yet</div>
                     }
                   </div>
            </div>
      )
    }

    getValuesForAttributeId(attributeId){
        var ret = [];
        if(!this.props.location.attributes[attributeId]){
            return false;
        }
        var choiceIds = this.props.location.attributes[attributeId].choice;
        for(var optionId in this.props.attributes[attributeId].options){
            if (_.contains(choiceIds, optionId)){
                ret.push(this.props.attributes[attributeId].options[optionId].name);
            }
        }
        return ret;

    }

    getFacilityType() {
        return [this.getValuesForAttributeId(attributeIds.facilityType)[0] + " Infusion Center"]
    }

    getPracticeType() {
        return [this.getValuesForAttributeId(attributeIds.practiceType)[0]]
    }

    getAcceptsOutsidePatients() {
        var choice = this.getValuesForAttributeId(attributeIds.acceptsOutsidePatients);
        if (!choice){
            return ["No"];
        }
        return choice;

    }

    iconForAttributeId(attributeId){
        return this.props.attributes[attributeId].icon;
    }

    render(){
        // console.log("attributeId: %o", attributeIds);
        return (
             <div className="quickFactsSection container vertical">
                 <div className="quickFactsHeader medicationsAvailableSectionHeader">Quick Facts</div>
                     {this.buildQuickFact(this.iconForAttributeId(attributeIds.practiceType), "Practice Type", this.getPracticeType())}
                     {this.buildQuickFact(infusionChairsIcon, "Infusion Chairs", [this.props.location.numberOfChairs])}
                     {this.buildQuickFact(this.iconForAttributeId(attributeIds.acceptsOutsidePatients), "Accepts Outside Patients", this.getAcceptsOutsidePatients())}
                     {this.buildQuickFact(this.iconForAttributeId(attributeIds.acceptedHealthCarePlans), "Accepted Health Plans", this.getValuesForAttributeId(attributeIds.acceptedHealthCarePlans))}
                     {this.props.location.languagesSpoken ?
                         <div className="container vertical-center quickFactsItem">
                               <img className="quickFactsIcon" src={languagesSpokenIcon} alt="quick facts icon" />
                               <div className="container vertical" style={{flex: 8, marginLeft: "16px"}}>
                                   <div className="quickFactsSubHeader">Languages Spoken</div>
                                   <div className="quickFactsValue">
                                        {this.props.location.languagesSpoken}
                                    </div>
                               </div>
                        </div>
                        :
                        null
                    }
            </div>
        )
    }
}

export default QuickFactsPanel;



// WEBPACK FOOTER //
// ./src/components/locator/details/QuickFactsPanel.js